// buy-now.js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.buy-now-button').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const form = btn.closest('form');
      if (!form) return;

      const formData = new FormData(form);
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Loading…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then((res) => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch((err) => {
          console.error(err);
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Something went wrong — please try again.');
        });
    });
  });
});